import react from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ClientRouter from "./ClientRouters";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<ClientRouter />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
